
        <div class="wrapper" [tooltipHtml]="helpTooltip" [tooltipTrigger]="'hover click'" tooltipContainer="body" [tooltipPlacement]="popUpPlacement" tooltipOffset="0,5" [tooltipEnable]="popUpPlacement!=='hidden'" (click)="openHelp($event)">
            <svg-icon name="question" [ngStyle]="{color: color}"></svg-icon><ng-content></ng-content>
            <div class="helpImg" *ngIf="imageUrl" [ngStyle]="{'background-image': imageUrl ? 'url(\'' + imageUrl + '\')' : null}"></div>
            <tooltip-template #helpTooltip [ngClass]="{helpImgTooltip: !key, helpKeyTooltip: key}">
                <img class="helpImgFull" src="{{imageUrl}}" *ngIf="imageUrl">
                <div *ngIf="key">{{'Help|Click_To_Open_Help'|translate}}</div>
            </tooltip-template>
        </div>
    